import { FC, FormEvent, useEffect, useState } from 'react';

import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';

interface Props {
    readonly minimum?: string;
    readonly maximum?: string;
    readonly minPlaceholder?: string;
    readonly maxPlaceholder?: string;
    readonly onChange: (minimum: string, maximum: string) => void;
    readonly testId: string;
}

const normalizeValue = (value?: string) =>
    value && value !== 'all' ? value : '';

export const NumberRangeFilter: FC<Props> = ({
    minimum,
    maximum,
    minPlaceholder = 'Від',
    maxPlaceholder = 'До',
    onChange,
    testId,
}) => {
    const [localMinimum, setLocalMinimum] = useState(normalizeValue(minimum));
    const [localMaximum, setLocalMaximum] = useState(normalizeValue(maximum));

    useEffect(() => {
        setLocalMinimum(normalizeValue(minimum));
        setLocalMaximum(normalizeValue(maximum));
    }, [maximum, minimum]);

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        onChange(localMinimum || 'all', localMaximum || 'all');
    };

    return (
        <form className="space-y-2" onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-2">
                <Input
                    type="number"
                    inputMode="decimal"
                    min="0"
                    step="any"
                    value={localMinimum}
                    placeholder={minPlaceholder}
                    aria-label="Мінімальне значення"
                    data-testid={`${testId}-min`}
                    onChange={(event) => setLocalMinimum(event.target.value)}
                />
                <Input
                    type="number"
                    inputMode="decimal"
                    min="0"
                    step="any"
                    value={localMaximum}
                    placeholder={maxPlaceholder}
                    aria-label="Максимальне значення"
                    data-testid={`${testId}-max`}
                    onChange={(event) => setLocalMaximum(event.target.value)}
                />
            </div>
            <Button
                type="submit"
                variant="outline"
                size="sm"
                className="h-8 w-full rounded-xl"
                data-testid={`${testId}-apply`}
            >
                Застосувати діапазон
            </Button>
        </form>
    );
};
